export const inbox = {
  titles: {
    inbox: "Posta in arrivo",
    unifiedInbox: "La tua posta in arrivo, unificata",
  },
  subtitles: {
    manageMessages: "Gestisci i messaggi dei tuoi canali di prenotazione",
    unifiedDesc:
      "Qui vedrai tutte le conversazioni con i tuoi ospiti, indipendentemente dal fatto che scrivano da Airbnb, Booking o un altro canale.",
    subscribeHint:
      "Abbonati per attivare la tua posta in arrivo e semplificare le tue comunicazioni.",
    planOnly:
      "Questo modulo è disponibile solo per i piani {plans}.",
  },
  states: {
    notInstalledTitle: "Modulo messaggi non installato",
    notInstalledDesc:
      "Installa il modulo di messaggistica per connetterti con i tuoi canali di prenotazione.",
    noChannelsTitle: "Nessun canale connesso",
    noChannelsDesc:
      "Per utilizzare il modulo di messaggistica, deve essere connesso almeno un canale (Booking.com, Airbnb).",
    noAccessTitle: "Non hai accesso al modulo messaggi",
  },
  actions: {
    installModule: "Installa il modulo messaggi",
    configureChannel: "Configura canale",
  },
  toasts: {
    connectChannelRequiredTitle: "Connessione richiesta",
    connectChannelRequiredBody:
      "Connetti almeno un canale di prenotazione per installare il modulo messaggi.",
  },
  errors: {
    notFoundPropertyOrUser: "Struttura o utente non trovati.",
    channelConnectGeneric:
      "Errore di connessione al canale. Riprova.",
    generateTokenError: "Errore durante la generazione del token",
  },
};
